import { validListValueValidator } from './validListValueValidator';

export const FORM_VALIDATION_TYPES = {
  VALID_LIST_VALUE: 'VALID_LIST_VALUE'
};

export const formValidationMap = {
  [FORM_VALIDATION_TYPES.VALID_LIST_VALUE]: validListValueValidator
};
